<template>
  <div class="popSearch">
    <!-- input框 -->
    <div class="popSearch-parent">
      <input class="inp" type="text" :id="id" :placeholder="placeholder" v-model="backUpValue" :class='classs'
             :anchor='name' @click="openPop" readonly="readonly"/>
      <i class="iconfont icon-xia"></i>
    </div>
    <!-- pop弹出层 -->
    <mt-popup v-model="popupVisible" position="right">
      <!-- 黑色头部插件 -->
      <div class="topsHeader">
        <mt-header :title="title" fixed :style="{backgroundColor:bgcolor}">
          <i class="mintui mintui-back" @click="leftBack()" slot="left"></i>

        </mt-header>
      </div>
      <!-- 弹出层内容（搜索和列表） -->
      <div class="autoSearch">
        <div class="autoSearchTop">
          <div class="searchBox">
            <mt-search v-model="value" :placeholder="searchPlaceholder" @input="input(value)"
                       :cancel-text="$t('cancel')"></mt-search>
            <div class="autocomplete transition ">
              <template v-if="showList">
                <slot name='list'>
                  <ul class="auto-searchList">
                    <li v-for="(data,key) in json" transition="showAll" class="listBox">
                      <a href="#" @click.prevent="selectList(data)">
                        <div class="detail" v-if='data.cardNo'>
                          <div class="top clearfix"><p class="left">{{$t('pop_search_cardNo')}}：{{data[anchor]}}</p>
                            <p style="float: right;margin-right: 8%;">{{data.name}}</p></div>
                          <div class="content clearfix">
                            <ul>
                              <!-- <li class="info">
                                  姓名：{{data.name}}
                              </li>
                              <li class="info">
                                  性别：{{data.sex}}
                              </li> -->

                              <li class="info" style="width:100%">
                                {{$t('pop_search_mobile')}}：{{data.mobile}}
                              </li>
                              <li class="info" style="width:100%">
                                {{$t('pop_search_idNo')}}：{{data.idNo}} （{{data.idTypeDis}}）
                              </li>

                              <li class="info">
                                {{$t('pop_search_cardType')}}：{{data. cardType}}
                              </li>
                              <li class="info">
                                {{$t('pop_search_rateCode')}}：{{data. rateCode}}
                              </li>
                              <i class="iconfont icon-you" style="top:1.8rem"></i>
                            </ul>
                          </div>
                        </div>
                        <div class="detail" v-else style="width: 97%;">
                          <div class="top clearfix"><p class="left">{{$t('pop_search_No')}}：{{data.id}}</p>
                            <p style="float: right;">{{data[anchor]}}</p></div>
                          <div class="content clearfix">
                            <ul>
                              <!-- <li class="info">
                                  编号：{{data.id}}
                              </li> -->
                              <li class="info">
                                {{$t('pop_search_rateCode')}}：{{data.rateCode}}
                              </li>
                              <li class="info">
                                {{$t('pop_search_saleman')}}：{{data.salemanDis}}
                              </li>
                              <i class="iconfont icon-you"></i>
                            </ul>
                          </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </slot>
              </template>
              <nothing :condition="!showList"></nothing>
            </div>

          </div>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
  import nothing from './nothing'
  import {Actionsheet} from "mint-ui";
  import {Popup} from "mint-ui";

  export default {
    data() {
      return {
        popupVisible: false,//弹框显示
        value: "",//搜素值
        showList: true,
        inputmodel: "",
        json: [],
        debounceTask: undefined,
        backUpValue: '',//输入框展示值
      }
    },
    props: {
      id: String,
      classs: String,
      name: String,
      placeholder: String,
      searchPlaceholder: String,
      //父组件模型名称
      model: String,
      //JSON数据取值的Key
      anchor: {
        type: String,
        required: true
      },
      debounce: Number,
      //拉取的数据个数的限制
      limit: {
        type: String,
        default: "5"
      },
      onSelect: Function,
      getData: {
        type: Function,
        required: true
      },
      initValue: {
        type: String,
        default: ""
      },
      // //这是黑色头部的prop
      // back: {
      //   default: true
      // },
      title: {
        default: ""
      },
      // url: {
      //   default: "/"
      // },
      // selfMethod: {
      //   default: ""
      // },
      // replace: {
      //   default: "true"
      // },
      bgcolor: {
        default: "#393C41"
      }
    },
    mounted() {
    },
    methods: {
      //打开popup弹框
      openPop() {
        //   this.value=this.backUpValue;
        //   console.log(this.backUpValue)
        this.popupVisible = !this.popupVisible;
      },
      //选中列表中的哪一项
      selectList(data) {
        const clean = this.cleanUp(data);
        //按照指定的JSON键值显示在模型上
        this.backUpValue = clean[this.anchor];
        this.popupVisible = false;
        // Callback Event
        this.onSelect ? this.onSelect(clean) : null;
      },
      //转化JSON对象
      cleanUp(data) {
        return JSON.parse(JSON.stringify(data));
      },
      input(val) {
        //触发调用getData方法
        // If Debounce

        if (this.debounce) {
          if (this.debounceTask !== undefined) clearTimeout(this.debounceTask);
          this.json = "";
          this.debounceTask = setTimeout(() => {
            this.getData(val);
          }, this.debounce);
        } else {
          this.json = "";
          this.getData(val);
        }
      },
      //下面都是黑色头部事件
      leftBack() {
        // this.value=this.backUpValue
        this.popupVisible = false;
        this.showList = true
      },
      gohome() {
        this.$router.push("/opera/");
      },
      refresh() {
        location.reload();
      },
    },
    watch: {},
    created() {
      //同步从父组件传递过来的值

      // this.inputmodel = this.initValue ? this.initValue : null;
    },
    components: {
      Popup, nothing
    }
  };
</script>

<style lang='less'>
  .popSearch {
    float: right;

    .popSearch-parent {
      position: relative;
      margin: 0 0.13333333rem;
      padding: 0 0.13333333rem;
      float: right;
      width: 6.86666667rem;
      box-sizing: border-box;
      height: 0.88rem;
      background: #fff;
      border: 1px solid #e8e8e8;

      input {
        border: none;
        width: 100%;
        height: 0.82rem;
        box-sizing: border-box;
      }

      .iconfont {
        position: absolute;
        right: 0.26666667rem;
        top: 0px;
      }
    }

    .mint-popup-right {
      width: 100%;
      height: 100%;

      .topsHeader {
        z-index: 2000;
        position: fixed;
        height: 1.04rem;

        .mint-header {
          color: #fff;
          font-size: 16px;
          top: -1px;
          z-index: 100;
          padding: 0;

          .mint-header-button {
            padding: 0 0.2rem;

            .mintui-back {
              font-size: 0.7rem;
              line-height: 0.853333rem;
              color: #fff;
            }

            .mint-button {
              .mint-button-icon {
                float: right;
              }
            }
          }
        }
      }

      .autoSearch {
        position: fixed;
        top: 1.04rem;
        left: 0;
        z-index: 1000;
        width: 100%;
        background: #fff;
        height: 100%;

        .mint-searchbar {
          background: none;
          border-radius: 5px;
        }

        .mint-searchbar-inner {
          background: #efefef;
          border-radius: 1rem;
        }

        .mint-searchbar-core {
          text-indent: 0.3rem;
          background: #efefef;
          border: none !important;
        }

        .mintui-search {
          font-size: 0.5rem;
          margin-left: 0.2rem;
        }

        .mint-searchbar-cancel {
          color: #000;
        }

        .mint-cell-wrapper {
          font-size: 0.35rem;
          border-bottom: 1px solid #ccc;
          width: 90%;
          margin: 0 auto;
        }

        .mint-search-list {
          top: 8px;
          // .mint-search-list-warp {
          //   border-top: 5px solid #efefef;
          // }
        }

        .autoSearchTop {
          background-color: #fff;
          height: 1.666667rem;

          .searchBox {
            input {
              height: 100%;
            }
          }
        }

        .mint-search-list-warp .mint-cell:nth-of-type(1) .mint-cell-wrapper {
          background-image: none;
        }
      }
    }

    .autocomplete {
      position: fixed;
      top: 2.6rem;
      width: 100%;
      height: ~"calc(100% - 101px)";
      overflow: hidden;

      .auto-searchList {
        margin: 0 auto;
        width: 90%;
        height: 100%;
        overflow-y: scroll;

        .listBox {
          border-bottom: 2px solid #e8e8e8;

          a {
            .detail {
              width: 100%;
              line-height: 14px;
              font-size: 12px;
              background-color: #fff;
              border-bottom: none;

              .top {
                padding: 6px 8px;
                color: #000;
                border-bottom: 1px dashed #ddd;

                .left {
                  float: left;
                }

                .right {
                  float: right;

                  span {
                    color: #d0011b;
                  }
                }
              }

              .content {
                .info {
                  color: #333;
                  float: left;
                  box-sizing: border-box;
                  height: auto;
                  line-height: 22px;
                  font-size: 12px;
                  overflow: hidden;
                  //   text-overflow: ellipsis;
                  //   white-space: nowrap;
                  word-wrap: break-word;
                }

                .info:nth-of-type(2n-1) {
                  width: 50%;
                  //   padding-left: 13px;
                }

                .info:nth-of-type(2n) {
                  width: 50%;
                }

                .iconfont {
                  position: absolute;
                  right: -1px;
                  //   top: 0.7rem;
                  top: ~"calc(38%)";
                  color: #9b9b9b;
                }
              }
            }
          }
        }
      }
    }

    .transition,
    .autocomplete,
    .showAll-transition,
    .autocomplete ul,
    .autocomplete ul li a {
      transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
      -webkit-transition: all 0.3s ease-out;
      -o-transition: all 0.3s ease-out;
    }

    .autocomplete ul li a {
      text-decoration: none;
      display: block;
      color: #000;
      padding: 5px;
    }

    .autocomplete ul li a b {
      font-weight: normal;
    }

    .autocomplete ul li {
      width: 100%;
      background: #fff;
      position: relative;
      z-index: 1;
      height: auto;
      line-height: 21px;
      font-size: 12px;
    }

    .showAll-transition {
      opacity: 1;
      height: 50px;
      overflow: hidden;
    }

    .showAll-enter {
      opacity: 0.3;
      height: 0;
    }

    .showAll-leave {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// popSearch.vue?e369a30c